export const posts = (state) => {
  return state.posts
}


export const post = (state) => {
  return state.post
}
